import styled from 'styled-components';

export const InnerFrameWrapper = styled.div`
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 40%;

    > div.loading-message {
        padding: 4rem 1rem;
        opacity: 1;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
    }
`;
